const COLOR_MAP = {
  blue: {
    border: 'border-l-blue-500',
    text: 'text-blue-500',
    bg: 'bg-blue-50',
  },
  amber: {
    border: 'border-l-amber-500',
    text: 'text-amber-500',
    bg: 'bg-amber-50',
  },
  green: {
    border: 'border-l-emerald-500',
    text: 'text-emerald-500',
    bg: 'bg-emerald-50',
  },
  orange: {
    border: 'border-l-orange-500',
    text: 'text-orange-500',
    bg: 'bg-orange-50',
  },
  cyan: {
    border: 'border-l-cyan-500',
    text: 'text-cyan-500',
    bg: 'bg-cyan-50',
  },
  yellow: {
    border: 'border-l-yellow-500',
    text: 'text-yellow-500',
    bg: 'bg-yellow-50',
  },
  purple: {
    border: 'border-l-purple-500',
    text: 'text-purple-500',
    bg: 'bg-purple-50',
  },
  slate: {
    border: 'border-l-slate-400',
    text: 'text-slate-400',
    bg: 'bg-slate-50',
  },
  gray: {
    border: 'border-l-gray-300',
    text: 'text-gray-400',
    bg: 'bg-gray-50',
  },
};

export function DetailSection({ icon: Icon, title, color = 'blue', span = false, children }) {
  const c = COLOR_MAP[color] || COLOR_MAP.blue;
  return (
    <div className={`rounded-xl bg-white shadow-sm border border-slate-200 border-l-4 ${c.border} overflow-hidden${span ? ' md:col-span-2' : ''}`}>
      <div className="flex items-center gap-2.5 px-4 pt-4 pb-2">
        {Icon && <div className={`flex items-center justify-center h-7 w-7 rounded-lg ${c.bg}`}>
          <Icon className={`h-4 w-4 ${c.text}`} />
        </div>}
        <h4 className="text-sm font-bold text-gray-800 uppercase tracking-wide">{title}</h4>
      </div>
      <div className="px-4 pb-4">
        {children}
      </div>
    </div>
  );
}

export function DetailRow({ label, value }) {
  if (value === null || value === undefined || value === '') return null;
  return (
    <div className="flex items-baseline justify-between gap-4 py-2 px-2 rounded-lg even:bg-slate-50/60">
      <dt className="text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap">{label}</dt>
      <dd className="text-sm font-semibold text-gray-900 text-right">{value}</dd>
    </div>
  );
}

export function getDirectionsUrl({ latitude, longitude, address, city, state, zipCode }) {
  const base = 'https://www.google.com/maps/dir/?api=1&destination=';
  if (latitude && longitude && latitude !== '' && longitude !== '') {
    return `${base}${latitude},${longitude}`;
  }
  const parts = [address, city, state, zipCode].filter(Boolean).join(', ');
  if (parts) return `${base}${encodeURIComponent(parts)}`;
  return null;
}

export function StatPill({ label, value, variant = 'default' }) {
  const variants = {
    default: 'bg-white/20 text-white',
    success: 'bg-emerald-400/20 text-emerald-50',
    warning: 'bg-amber-400/20 text-amber-50',
    danger: 'bg-red-400/20 text-red-50',
  };
  const cls = variants[variant] || variants.default;
  return (
    <div className={`flex flex-col items-center px-4 py-2 rounded-xl ${cls} backdrop-blur-sm`}>
      <span className="text-[10px] font-medium uppercase tracking-wider opacity-80">{label}</span>
      <span className="text-sm font-bold mt-0.5">{value}</span>
    </div>
  );
}
